import { Grid, styled } from "@mui/material";

export const Container = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

export const TopHeader = styled(Grid)({
  display: "flex",
  gap: "10px",
});
